module.exports = __webpack_public_path__ + "static/media/prayer.32c20744.jpeg";